import { CourseType } from "../CourseType.js";
import { Locale, type LocalizedString } from "../Locale.js";

export const courseTypeNameMap: Record<CourseType, LocalizedString> = {
	[CourseType.HomeFilterCoffee]: {
		[Locale.cs]: "Kurz domácí filtrované kávy",
		[Locale.en]: "Home filter coffee course",
	},
	[CourseType.HomeEspresso]: {
		[Locale.cs]: "Kurz domácí espresso",
		[Locale.en]: "Home espresso course",
	},
	[CourseType.SCAFoundation]: {
		[Locale.cs]: "SCA základní baristický kurz",
		[Locale.en]: "SCA Foundation Barista Course",
	},
	[CourseType.SCAIntermediate]: {
		[Locale.cs]: "SCA pokročilý baristický kurz",
		[Locale.en]: "SCA Advanced Barista Course",
	},
};
